// extracted by mini-css-extract-plugin
module.exports = {"arrow-btn-box":"a0","arrowBtnBox":"a0","arrow-btn-wrap-box":"a1","arrowBtnWrapBox":"a1","arrow-btn-text":"a2","arrowBtnText":"a2","arrow-btn-arrow":"a3","arrowBtnArrow":"a3"};